import type { components } from '@/api/qraft/schema';
import { tr, trDynamic } from './strings';

export type ProfileType = components['schemas']['ProfileType'];
export type StaffTier = components['schemas']['StaffTier'];

export const STUDENT_TYPES = [
  'WEB_STUDENT',
  'LITEAPP_STUDENT',
  'POSTAL_STUDENT',
  'EMAIL_STUDENT',
] as const satisfies ProfileType[];

/** Every type a person can hold; the deleted-user sentinel is never listed. */
export const PERSON_TYPES = [
  ...STUDENT_TYPES,
  'STUDY_HELPER',
  'FOLLOWUP_COORDINATOR',
  'FOLLOWUP_PARTNER',
  'ADMIN',
] as const satisfies ProfileType[];

export const STAFF_TIERS: StaffTier[] = [
  'FRONT_END_SUPPORT',
  'SUPPORT',
  'ADMIN',
];

export function isStudentType(type: ProfileType): boolean {
  return (STUDENT_TYPES as readonly string[]).includes(type);
}

export function profileTypeLabel(type: ProfileType): string {
  return trDynamic(
    `admin.people.profileTypes.${type}`,
    type.replaceAll('_', ' ').toLowerCase(),
  );
}

export function tierLabel(tier: StaffTier): string {
  return trDynamic(`admin.people.tiers.${tier}`, tier);
}

export function genderLabel(gender: 'male' | 'female' | 'unknown'): string {
  return tr(`admin.people.gender.${gender}`);
}
